module.exports = __webpack_public_path__ + "Icono_Tiempo-Bco_126px.png";